module.exports = __webpack_public_path__ + "html/coupon_d0c35d468cb0c83c174fffaf9067a4e4.html";


//////////////////
// WEBPACK FOOTER
// ./app/assets/html/upgrade/coupon.html
// module id = 52SV
// module chunks = 3